import { TabFabVariantType } from '../../../../../../components/tabFab/types/tabFab';
import { commonContainerStyles, commonDotStyles, commonIconStyles } from '../commonStyles/common';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [TabFabVariantType.REGULAR]: {
            container: {
                ...commonContainerStyles(FOUNDATIONS, FONT),
            },
            icon: {
                ...commonIconStyles(FOUNDATIONS, FONT),
            },
            dot: {
                ...commonDotStyles(FOUNDATIONS, FONT),
            },
            animationDuration: FOUNDATIONS.duration_150,
        },
    };
};
//# sourceMappingURL=regular.js.map